<template>
  <div class="cta">
    <h4>Herzlich willkommen!</h4>
    <p class="cta__subtitle">Hier können Sie Ihre Termine erstellen, verwalten und stornieren</p>
    <CtaBox
      title="Einloggen und Termin buchen"
      subtitle="Sie müssen angemeldet sein, um fortfahren zu können"
      :clickable="true"
      @click="redirectToLogin"
    >
      <template #icon><IconAccount aria-hidden="true" /></template>
    </CtaBox>
  </div>
</template>

<script>
import CtaBox from './CtaBox.vue'
import IconAccount from '@/components/icons/IconAccount.vue'
import { redirectToLogin } from '@/utils/misc.js'

export default {
  components: { CtaBox, IconAccount },
  methods: {
    redirectToLogin,
  },
}
</script>
